import { render } from "./FavoritesSongs.vue?vue&type=template&id=48edd9e2"
import script from "./FavoritesSongs.vue?vue&type=script&lang=js"
export * from "./FavoritesSongs.vue?vue&type=script&lang=js"

import "./FavoritesSongs.vue?vue&type=style&index=0&id=48edd9e2&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__